import script from "./CatalogImport.vue?vue&type=script&setup=true&lang=js"
export * from "./CatalogImport.vue?vue&type=script&setup=true&lang=js"

import "./CatalogImport.vue?vue&type=style&index=0&id=3d56c9b7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3d56c9b7"]])

export default __exports__